"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.boundarySection = void 0;
const types_1 = require("../../../types");
exports.boundarySection = {
    label: "form.boundaryAdditional.label",
    name: "additional_boundaries",
    parent: "boundary",
    subline: "form.boundaryAdditional.subline",
    info: "form.boundaryAdditional.info",
    isList: true,
    count: 1,
    fields: [
        {
            name: "description",
            label: "form.boundaryAdditional.description",
            type: types_1.FormFieldType.full,
        },
        {
            name: "value",
            label: "form.boundaryAdditional.value",
            type: types_1.FormFieldType.full,
        },
    ],
};
exports.default = exports.boundarySection;
